import { BaseService } from './BaseService';

export class CouponService extends BaseService {

  async getCoupons(){
    const response = {
      ok: false,
      coupons: [],
      message: ''
    };
    try {
      const result = await this.http('app/coupons', 'get', {});
      response.coupons = result;
      response.ok = true;
    } catch (error) {
      response.message = error.message;
      response.ok = false;
    }
    return response;
  }

  async addCoupon(name, total){
    const response = {
      ok: false,
      message: ''
    };
    try {
      return this.httpPost('app/coupons', {
        name,
        total
      });
    } catch (error) {
      response.message = error.message;
      response.ok = false;
    }
    return response;
  }
  
  async editCoupon(id, total, available){
    const response = {
      ok: false,
      message: ''
    };
    try {
      return this.http(`app/coupons/${id}`, 'put', {
        total, 
        available
      });
    } catch (error) {
      response.message = error.message;
      response.ok = false;
    }
    return response;
  }
  
  async deleteCoupon(id){
    const response = {
      ok: false,
      message: ''
    };
    try {
      return this.http(`app/coupons/${id}`, 'delete', {});
    } catch (error) {
      response.message = error.message;
      response.ok = false;
    }
    return response;
  }
}